import moment from 'moment';

import { ct, ITProps, TKey } from '~/src/dash/publicaUI';

export interface IStartToEndDateRanges {
  startDateFrom: moment.Moment | null;
  startDateTo: moment.Moment | null;
  endDateFrom: moment.Moment | null;
  endDateTo: moment.Moment | null;
}

export interface IValidateDateRangesOutput {
  isValid: boolean;
  errorTKey: TKey;
  errorTProps: ITProps;
}

export const validateDateRanges = ({
  startDateFrom,
  startDateTo,
  endDateFrom,
  endDateTo,
}: IStartToEndDateRanges): IValidateDateRangesOutput => {
  if (
    (startDateFrom && startDateTo && startDateTo < startDateFrom) ||
    (startDateTo && endDateFrom && startDateTo > endDateFrom) ||
    (startDateFrom && endDateFrom && endDateFrom < startDateFrom) ||
    (startDateTo && endDateFrom && endDateFrom < startDateTo) ||
    (endDateFrom && endDateTo && endDateTo < endDateFrom) ||
    (endDateTo && startDateFrom && endDateTo < startDateFrom) ||
    (endDateTo && startDateTo && endDateTo < startDateTo)
  ) {
    return {
      isValid: false,
      errorTKey: 'ItemIsInvalid',
      errorTProps: {
        item: ct('DateRange'),
      },
    };
  }
  return {
    isValid: true,
    errorTKey: '',
    errorTProps: {},
  };
};
